import { SYSTEM } from '../base/contextService';
import { $window } from '../common/utils/bom';
import { ToolsSwitch } from '../interface/enterpriseInfo';
export function getUpgradeUrl(system: string, memberType: number) {
    if (memberType === 2 && system === SYSTEM.CN) {
        return '/account/member';
    }
    return '/plan/pricing?platform=pc';
}
export const isEnterprise = (eid?: string | number) => {
    if (typeof eid === 'string') {
        return !!eid && eid !== '0';
    }
    return !!eid && eid > 0;
};

type UnknownType = string | number | object;
export type UnknownObj = { [key: string]: unknown };

const isObject = (obj: any) => {
    return Object.prototype.toString.call(obj) === '[object Object]';
};

const isSameObj = (obj1: UnknownObj, obj2: UnknownObj) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const getParametersByObj = (param: Object) => {
    let result = '';
    if (param) {
        for (const i in param) {
            const item = (param as any)[i];
            if (item !== '') {
                const split = result === '' ? '' : '&';
                result += `${split}${i}=${item}`;
            }
        }
    }
    return result;
};
// 重定向页面 参数
export const gotoAuthPanel = (url: string, param: Object) => {
    const suffix = getParametersByObj(param);
    url += suffix === '' ? '' : '?' + suffix;
    window.location.href = url;
};
/**
 * 对比两个值是否相等, 弱类型比较
 * @param {string | number | object}
 * @return {boolean}
 */
export const isSame = (v1?: UnknownType, v2?: UnknownType) => {
    if (!v1 || !v2) {
        return v1 === v2;
    }
    if (isObject(v1) && isObject(v2)) {
        return isSameObj(v1 as UnknownObj, v2 as UnknownObj);
    }
    return v1.toString() === v2.toString();
};

export const isOnlyAITools = (isInAITools: boolean, isEnterpriseAccount: boolean, userId: string) => {
    if (!isInAITools) {
        return false;
    }
    const enterpriseSetting = ($window.pageData as any)?.enterprise_setting || {};
    const aiToolsSwitch = isEnterpriseAccount
        ? ((enterpriseSetting?.setup?.enable_ai_tools || 0) as ToolsSwitch)
        : userId
        ? ToolsSwitch.open
        : ToolsSwitch.notOpen;
    return aiToolsSwitch === ToolsSwitch.onlyTools;
};
